<header id="main-menu-header" class="header fixed-top d-flex align-items-center">
	<div class="d-flex align-items-center justify-content-between">
		<a [routerLink]="[homeUrl]" class="logo d-flex align-items-center">
			<img src="../assets/img/3Cube-dark.png" alt="">
		</a>
		<a mat-button [routerLink]="[homeUrl]" [routerLinkActive]="'menu-active'" matTooltip="Home" class="nav-option">
			<fa-icon [icon]="['fas','home']" class="fs-16"></fa-icon>
		</a>
		<button mat-button [ngbPopover]="popContent1" placement="bottom" popoverClass="popup-menu" matTooltip="Menu"
			class="nav-option">
			<fa-icon [icon]="['fas','th']" class="fs-16"></fa-icon>
		</button>
		<ng-template #popContent1>
			<div class="fixHeightMenu">
				<div class="row g-0">
					<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item"
						[routerLink]="['/app/masters/list-news']" [routerLinkActive]="'popup-menu-active'">
						<p class="sub-menu-p">
							<fa-icon [icon]="['fas','newspaper']"></fa-icon>
							<br />
							Company News
						</p>
					</a>
					@if(
					user?.tms_access?.create_recurring_task ||
					user?.tms_access?.edit_recurring_task ||
					user?.tms_access?.delete_recurring_task
					){
					<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item"
						[routerLink]="['/app/masters/list-rec-task']" [routerLinkActive]="'popup-menu-active'">
						<p class="sub-menu-p">
							<fa-icon [icon]="['fas','tasks']"></fa-icon>
							<br />
							Recurring Task
						</p>
					</a>
					}
					<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item" [routerLink]="['/app/attendance']"
						[routerLinkActive]="'popup-menu-active'">
						<p class="sub-menu-p">
							<fa-icon [icon]="['fas','user-clock']"></fa-icon>
							<br />
							Attendance
						</p>
					</a>
					@if(user?.tms_access?.regularization_module){
					<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item"
						[routerLink]="['/app/regularization']" [routerLinkActive]="'popup-menu-active'">
						<p class="sub-menu-p">
							<fa-icon [icon]="['fas','user-check']"></fa-icon>
							<br />
							Regularization
						</p>
					</a>
					}
					@if(user?.tms_access?.leave_module){
					<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item" [routerLink]="['/app/leave']"
						[routerLinkActive]="'popup-menu-active'">
						<p class="sub-menu-p">
							<fa-icon [icon]="['fas','user-times']"></fa-icon>
							<br />
							Leaves
						</p>
					</a>
					}
					@if(user?.tms_access?.roaster_module){
					<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item" [routerLink]="['/app/roaster']"
						[routerLinkActive]="'popup-menu-active'">
						<p class="sub-menu-p">
							<fa-icon [icon]="['fas','calendar-week']"></fa-icon>
							<br />
							Roaster
						</p>
					</a>
					}
					<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item" [routerLink]="['/app/masters/list-holiday']"
						[routerLinkActive]="'popup-menu-active'">
						<p class="sub-menu-p">
							<fa-icon [icon]="['fas','gift']"></fa-icon>
							<br />
							Holiday
						</p>
					</a>
					<a class="col-lg-4 col-md-4 col-sm-12 col-xs-12 popup-menu-item" [routerLink]="['/app/masters/list-event']"
						[routerLinkActive]="'popup-menu-active'">
						<p class="sub-menu-p">
							<fa-icon [icon]="['fas','trophy']"></fa-icon>
							<br />
							Event
						</p>
					</a>
				</div>
			</div>
		</ng-template>
	</div>
	<mat-toolbar>
	</mat-toolbar>
	<nav class="header-nav ms-2">
		<ul class="d-flex align-items-center">
			<li class="nav-item pe-3" style="width: max-content;">
				<h5 class="mb-0">
					<strong>
						{{user?.first_name}} {{user?.last_name}}
					</strong>
				</h5>
			</li>
			<li class="nav-item dropdown pe-3">
				<a class="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
					<span class="d-none d-md-block dropdown-toggle ps-2 nav-option">
						<fa-icon [icon]="['fas','user']"></fa-icon>
					</span>
				</a>
				<ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
					<li class="dropdown-header">
						<h6>
							{{user?.first_name}} {{user?.last_name}}
						</h6>
					</li>
					<li>
						<hr class="dropdown-divider">
					</li>
					<li>
						<!-- <a class="dropdown-item d-flex align-items-center" style="cursor: pointer;"
							(click)="openResetPasswordModal()">
							<fa-icon [icon]="['fas','lock']" class="me-2"></fa-icon>
							<span>Change Password</span>
						</a> -->
						<a class="dropdown-item d-flex align-items-center" style="cursor: pointer;"
							(click)="logoutUser()">
							<fa-icon [icon]="['fas','sign-out-alt']" class="me-2"></fa-icon>
							<span>Sign Out</span>
						</a>
					</li>
				</ul>
			</li>
		</ul>
	</nav>
</header>
<main id="page-content-container-common" class="main" [@routeAnimations]="prepareRoute(o)">
	<div *ngIf="userLoader" class="loader text-center">
		<img src="../../assets/img/loading.gif" />
		<p style="color: black;font-weight: bolder;">Loading...</p>
	</div>
	<router-outlet #o="outlet"></router-outlet>
</main>
<br />
<footer id="footer" class="footer fixed-bottom bg-light">
	<div class="row g-0">
		<div class="col"></div>
		<div class="col">
			<div class="copyright">
				&copy; Copyright <strong><span>3CubeMedicare</span></strong>.
				&nbsp;All Rights Reserved
			</div>
		</div>
		<div class="col">
			<fa-icon *ngIf="showScrollBtn" [icon]="['fas', 'angle-double-up']" (click)="scrollToTop()"
				matTooltip="Scroll to top" [matTooltipPosition]="'left'" class="float-end me-2" role="button"></fa-icon>
		</div>
	</div>
</footer>
<app-change-password-form></app-change-password-form>